import { default as Region } from './Region';

export { Region };



// WEBPACK FOOTER //
// src/modules/screens/settings/Region/components/index.js